import { BiilingInfo } from '@/components/settings/billing';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useInvalidateQuery } from '@/hooks/useInvalidateQuery';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/billing')({
  component: Billing,
});

function Billing() {
  const invalidateQuery = useInvalidateQuery();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      invalidateQuery(['organizations']);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [invalidateQuery]);

  return (
    <div className='pt-6 space-y-6'>
      <BiilingInfo />
    </div>
  );
}
